const kalenderMonthReducerDefaultState = {
    months: [],
  },
  kalenderMonthReducer = (state = kalenderMonthReducerDefaultState, action) => {
    switch (action.type) {
      case "KALENDER_MONAT_SET_MONTH_ACTION": {
        const configs = state.months.filter(
          (item) => item.id !== action.config.id
        );

        return Object.assign({}, state, {
          months: [...configs, action.config],
        });
      }
      default:
        return state;
    }
  };

export { kalenderMonthReducerDefaultState, kalenderMonthReducer };
